export const VALIDATOR_CONSTANTS = {
  DEFAULT_HIGH_MAX_NUMBER: 999999,
};
